/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { anchorLink } from 'gatsby-core-theme/src/helpers/strings';
import ModuleTitle from 'gatsby-core-theme/src/components/atoms/module-title';
import ModuleIntro from '~molecules/content';
import styles from './styles.module.scss';
import SeeMore from '../../../atoms/see-more';

export const removeSymbols = (string) => string.replace(/[!?@Â£#$%^&*():;"'|/.,~`]/g, '');

const ModuleIntroduction = ({ module, showSeeMore = false }) => {
  const anchorLabel = module?.anchor_label && removeSymbols(anchorLink(module?.anchor_label));

  const showModuleIntro = module?.module_introduction && module?.module_introduction !== '<p></p>';

  return (
    <div className={ModuleIntro ? '' : styles.noIntroModuleCards}>
      <ModuleTitle
        module={module}
        anchorLabel={module.name === 'archive' && anchorLabel}
        showMoreLink={!ModuleIntro}
      />
      {showModuleIntro && (
        <ModuleIntro
          isModuleIntroduction={module?.module_introduction}
          module={{ value: module?.module_introduction }}
        />
      )}
      {showSeeMore && ModuleIntro && <SeeMore module={module} />}
    </div>
  );
};

ModuleIntroduction.propTypes = {
  module: PropTypes.shape({
    anchor_label: PropTypes.string,
    name: PropTypes.string.isRequired,
    module_introduction: PropTypes.string,
    see_more_link: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
  showSeeMore: PropTypes.bool,
};

export default ModuleIntroduction;
